export default {
  title: "العملات",
  subtitle: "إدارة العملات وأسعار الصرف",
  
  // Actions
  addNew: "إضافة عملة جديدة",
  createCurrency: "إنشاء عملة",
  editCurrency: "تعديل العملة",
  deleteCurrency: "حذف العملة",
  currencyDetails: "تفاصيل العملة",

  actions: {
    back: "رجوع",
    update: "تحديث",
    updating: "جاري التحديث...",
    save: "حفظ",
    saving: "جاري الحفظ...",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف",
    create: "إنشاء",
    creating: "جاري الإنشاء..."
  },
  
  // Fields
  fields: {
    name: "اسم العملة",
    code: "رمز العملة",
    symbol: "الرمز",
    exchangeRate: "سعر الصرف",
    lastExchangeRate: "آخر سعر صرف",
    isBaseCurrency: "العملة الأساسية",
    status: "الحالة",
    hedge: "نسبة التحوط",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث"
  },
  
  // Placeholders
  placeholders: {
    name: "أدخل اسم العملة",
    code: "أدخل رمز العملة (مثل: USD)",
    symbol: "أدخل رمز العملة (مثل: $)",
    exchangeRate: "أدخل سعر الصرف",
    lastExchangeRate: "أدخل آخر سعر صرف",
    hedge: "أدخل نسبة التحوط"
  },
  
  // Messages
  messages: {
    createSuccess: "تم إنشاء العملة بنجاح",
    createError: "فشل في إنشاء العملة",
    updateSuccess: "تم تحديث العملة بنجاح",
    updateError: "فشل في تحديث العملة",
    deleteSuccess: "تم حذف العملة بنجاح",
    deleteError: "فشل في حذف العملة",
    deleteConfirm: "هل أنت متأكد من حذف هذه العملة؟",
    noCurrencies: "لا توجد عملات",
    loadingCurrencies: "جاري تحميل العملات...",
    fetchError: "فشل في جلب العملات",
    exchangeCreateSuccess: "تم إنشاء سعر الصرف بنجاح",
    exchangeCreateError: "فشل في إنشاء سعر الصرف"
  },
  
  // Validation
  validation: {
    nameRequired: "اسم العملة مطلوب",
    nameMinLength: "اسم العملة يجب أن يكون على الأقل حرفين",
    nameMaxLength: "اسم العملة يجب ألا يتجاوز 100 حرف",
    codeRequired: "رمز العملة مطلوب",
    codeFormat: "رمز العملة يجب أن يكون 3 أحرف (مثل: USD)",
    symbolRequired: "رمز العملة مطلوب",
    exchangeRateRequired: "سعر الصرف مطلوب",
    exchangeRateMin: "سعر الصرف يجب أن يكون أكبر من 0",
    exchangeRateMax: "سعر الصرف يجب ألا يتجاوز 999999"
  },
  
  // Table headers
  table: {
    name: "الاسم",
    code: "الرمز",
    symbol: "الرمز",
    exchangeRate: "سعر الصرف",
    lastExchangeRate: "آخر سعر",
    isBaseCurrency: "العملة الأساسية",
    status: "الحالة",
    actions: "خيارات الأوامر",
    hedge: "نسبة التحوط"
  },
  
  // Status options
  statusOptions: {
    active: "نشط",
    inactive: "غير نشط"
  },
  
  // Base currency options
  baseCurrencyOptions: {
    yes: "نعم",
    no: "لا"
  },
  
  // Exchange Rate
  exchangeRate: {
    addNew: "إضافة سعر صرف جديد",
    history: "تاريخ أسعار الصرف",
    date: "التاريخ",
    rate: "السعر",
    ratePlaceholder: "أدخل سعر الصرف",
    noRates: "لا توجد أسعار صرف"
  },

  // Breadcrumbs
  breadcrumbs: {
    currencies: "العملات",
    create: "إنشاء عملة",
    edit: "تعديل العملة",
    view: "عرض العملة"
  }
};
